import { useState } from 'react'
import Styles from './StartWithImageDrawer.module.scss'
import { SearchResults } from 'components/DesignAspectRatioPickerModal/SearchResults'
import { AspectRatioKey } from 'components/NewFileModal/Types'
import { Groups } from 'components/DesignAspectRatioPickerModal/Groups'
import { SearchField } from 'components/DesignAspectRatioPickerModal/SearchField'

interface Props {
  onSelect: (key: AspectRatioKey) => void
}

export const FileFormatSelection = ({ onSelect }: Props) => {
  const [query, setQuery] = useState('')

  const isSearching = query.length > 0

  return (
    <div className={Styles.fileFormatContainer}>
      <SearchField value={query} onChange={setQuery} />
      {isSearching ? <SearchResults query={query} onSelect={onSelect} /> : <Groups onSelect={onSelect} />}
    </div>
  )
}
